import React, { Component } from "react";

import PlaybookRunService from "../../services/PlaybookRunService";

import "./agent-run-outcome.css";

class AgentRunOutcome extends Component {
	render() {
		const { run, showReason = true } = this.props;
		const status = PlaybookRunService.describeRunOutcome({ run });
		const reason = PlaybookRunService.reasonRunDidNotRun({ run });

		return (
			<span className="agent-run-outcome">
				<span className="agent-run-outcome__status">
					<span className={`tk-dot tk-dot--${status.tone}`} />
					{status.label}
				</span>
				{showReason && reason && (
					<span className="agent-run-outcome__reason" title={reason}>
						{reason}
					</span>
				)}
			</span>
		);
	}
}

export default AgentRunOutcome;
